const blog = {
  title: 'PEGASUS ARMS Blog',
  socLinks: 'We are on social media',
  back: 'Back',
  more: 'Read more',
  all: 'All articles',
  interested: 'You may be interested',
  articleZero: {
    date: '25.12.2025',
    title:
      'A trained crew means effective sorties: how Pegasus Arms 25 drone operators are prepared',
    paragraphs: [
      'Learning to fly a drone isn’t difficult. What’s difficult is learning to fly in a way that ensures the number of takeoffs equals the number of landings—and that every sortie delivers results. That’s exactly what trainees are taught at NCVT MIST, a private training center that prepares pilots for heavy bomber drones such as the Pegasus Arms 25.',
      'Becoming a certified heavy-drone pilot takes three weeks. During this time, the crew completes a comprehensive training program that includes:',
    ],
    lists: {
      items: [
        '▪️ 36 academic hours of theory and practical training;',
        '▪️ 36 hours of flight training;',
        '▪️ operating PEGASUS ARMS 25 strike UAVs with various types of payloads;',
        '▪️ executing combat missions and operating in challenging weather conditions;',
        '▪️ countering enemy drones and employing EW/ELINT and anti-drone systems.',
      ],
    },
    links: {
      title:
        'Journalists from the ICTV “Fakty” program covered the training process in the following report:',
      link: 'https://youtu.be/rm4wzWsdpsw?si=QqyU4k270yRlA02S',
    },
  },
  articleOne: {
    date: '23.10.2025',
    title: 'EVERY SCREW MATTERS. AND SO DO YOU - AT PEGASUS ARMS.',
    paragraphs: [
      'We operate where precision matters – where every millimeter and every move counts.',
      'If you think systematically, value quality, and want to grow in the miltech field - join us.',
      'We are expanding our team and looking for those who don’t just want a job but are eager to create an advantage, stand guard over the sky, and change the rules of the game.',
    ],
    lists: {
      title: 'OUR BENEFITS:',
      items: [
        '▪️ Official employment',
        '▪️ Deferral of employees from military service',
        '▪️ Competitive salary',
        '▪️ Comfortable working conditions',
        '▪️ Training and support',
        '▪️ 24 calendar days of paid vacation',
        '▪️ Paid sick leave',
      ],
    },
    links: {
      title:
        '🗂️ Full list of vacancies available on DOU (link in profile header)',
      link: 'https://jobs.dou.ua/companies/tov-pegas-arms/vacancies/',
    },
  },

  articleTwo: {
    date: '23.10.2025',
    title: 'Why is the Pegasus Arms 25 EW resistant?',
    paragraphs: [
      '”YOUR DRONE WILL BE GROUNDED BY THE FIRST EW SYSTEM!”, say those who saw UAVs only on social media and confuse Pegasus Arms 25 with other drones.',
      'Actually, that’s not true.',
      'The operator does not lose control and our drone doesn’t “fall into a corn field” when exposed to EW.',
      'Why is the Pegasus Arms 25 EW resistant?',
      '➡️ FREQUENCY AGILITY: it operates across a spectrum of frequencies that are difficult to track. If a signal is jammed, the drone automatically switches to another frequency.',
      '➡️ STRONG ENCRYPTION: the protected control channel prevents interception or enemy interference.',
      '➡️ PILOT SUPPORT: even in powerful EW zones, the drone retains control and functionality under signal disruption.',
      '➡️ FUNCTIONAL ADAPTABILITY: before each flight, the system adjusts to the threat type, terrain, and level of electronic interference.',
      'The key point is not just to launch the drone, but to ensure it successfully completes its mission and returns to safety.',
      'Our strike UAV has already done it dozens of times.',
    ],
  },
}

export default blog
